import React, { Component } from 'react';
import './Seat.css';

import Player from './Player';

class Seat extends Component {
  constructor(props) {
    super(props);
    this.onSit = this.onSit.bind(this);
  }

  onSit() {
    this.props.onSit(this.props.pos);
  }

  render() {
    if (this.props.seat && this.props.seat.player) {
      const cards = (this.props.hideCards ? 
               {hole: [], door: []} : this.props.seat.cards);
      return (
        <div className={`seat has-player pos-${this.props.pos}`}>
          <Player player={this.props.seat.player}
                  cards={cards}
                  winner={this.props.seat.winner}
                  bet={this.props.seat.bet}
                  animations={this.props.seat.animations}
          />
        </div>
      );
    } else {
      const button = this.props.userIsSeated ? '' : (
        <button className="sit" onClick={this.onSit}>
          Sit
        </button>
      );
      const seated = this.props.userIsSeated ? 'seated' : 'not-seated';
      return (
        <div className={`seat no-player ${seated} pos-${this.props.pos}`}>
          {button}
        </div>
      );
    }
  }
}

export default Seat;



// WEBPACK FOOTER //
// ./src/Seat.js